// Phase 6 (DNS cutover) 完了後の状態:
// - admin.sociama.org / admin-new.sociama.org → 両方 prod CloudFront (sociama account)
// - api.sociama.org → prod APIGW (sociama account)
// - dev pool の SPA は今後アクセスされない
// - localhost:5173 は開発用で dev API + dev pool を使う (別途 dev CDK stack を Phase 7 で削除する前提)
const host =
  typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalhost = host === 'localhost';

export const CONFIG = isLocalhost
  ? {
      apiBase: 'https://api.sociama.org',
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_yJ8rIzqIk',
      clientId: '3df4cr32ca9lg3q5vd8s6vlo3a',
      cognitoDomain:
        'https://apps-hub-prod.auth.ap-northeast-1.amazoncognito.com',
      redirectUri: 'http://localhost:5173/callback',
      logoutRedirect: 'http://localhost:5173/',
    }
  : {
      apiBase: 'https://api.sociama.org',
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_yJ8rIzqIk',
      clientId: '3df4cr32ca9lg3q5vd8s6vlo3a',
      cognitoDomain:
        'https://apps-hub-prod.auth.ap-northeast-1.amazoncognito.com',
      redirectUri: `https://${host}/callback`,
      logoutRedirect: `https://${host}/`,
    };
